import React from "react";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SIDEBAR_EXPANDED, SIDEBAR_WIDTH } from "./Sidebar";
import Tour from "./Tour";
import { toLower } from "lodash";

const useStyles = createUseStyles(theme => ({
  container: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  title: {
    height: 70,
    width: "100%",
    display: "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "space-between",

    "& h2": {
      color: "white",
      margin: 0,
    },

    "& a": {
      display: "block",
      "text-decoration": "none",
      color: "white",
      "background-color": theme.colorRed,
      border: "none",
      "border-radius": 3,
      cursor: "pointer",
      padding: [6, 20],
      "font-size": 14,
      margin: [0, 15],
    },
  },
  grow: { "flex-grow": 1 },
  tours: {
    display: "flex",
    "flex-direction": "row",
    "flex-wrap": "wrap",
    padding: [15, 0, 15, 15],
    "overflow-y": props => (props.loading ? "hidden" : "auto"),
    "box-sizing": "border-box",
    "max-height": "calc(100% - 161px)",
  },
  group: {
    extend: "tours",
    width: "100%",
    padding: 0,

    "& h3": {
      width: "100%",
      color: "white",
      cursor: "pointer",

      "&:hover": {
        "text-decoration": "underline",
      },
    },
  },
  account: {
    "background-color": "#252525",
    padding: [10, 0],
    margin: [0, 15, 15, 0],
    display: "flex",
    "flex-direction": "row",
    "align-items": "center",
    width: SIDEBAR_WIDTH - 8,
    height: SIDEBAR_EXPANDED - 30,
    "flex-shrink": 0,
    transition: "background-color 0.2s ease",
    cursor: "pointer",
    "border-radius": 3,

    "&:hover": {
      "background-color": "#313131",
    },

    "& img": {
      "max-height": SIDEBAR_EXPANDED - 30,
      "max-width": SIDEBAR_EXPANDED - 30,
      "border-radius": 3,
      margin: [0, 15, 0, 10],
    },

    "& $svg": {
      color: theme.colorRed,
      margin: [0, 15, 0, 10],
      width: SIDEBAR_EXPANDED - 32,
      height: SIDEBAR_EXPANDED - 32,
      border: "1px solid #313131",
      "border-radius": 3,
      display: "flex",
      "align-items": "center",
      "justify-content": "center",

      "& svg": {
        height: "100%",
      },
    },

    "& h3": {
      color: "white",
      margin: 0,
      "padding-right": 25,
    },
  },
  svg: {},
}));

const sortedTours = (tours = []) => {
  return tours.sort((a, b) => toLower(a.title).localeCompare(toLower(b.title)))
}

const Content = ({
  icon,
  title,
  team,
  loading,
  tours,
  searching,
  setActiveAccount,
  clearSearch,
  searchTab,
  accounts,
  account,
  children,
}) => {
  const classes = useStyles({ loading });

  const getLoading = () =>
    Array.from({ length: 12 }, () => Math.random()).map(key => (
      <Tour key={key} tour={{ title: "", token: "" }} loading />
    ));

  const getSearchTour = () => {
    switch (searchTab) {
      case "Tours":
        if (loading) return getLoading();
        return tours.map(group => (
          <div key={group.id} className={classes.group}>
            <h3
              onClick={() => {
                clearSearch();
                setActiveAccount({ ...group, tours: undefined });
              }}
            >
              {group.name}
            </h3>
            {sortedTours(group.tours).map(tour => (
              <Tour key={tour.token} tour={tour} />
            ))}
          </div>
        ));
      case "Accounts":
        return accounts.map(account => {
          return (
            <div key={account.id} className={classes.account}>
              {account.logo ? (
                <img src={account.logo} alt={account.name} />
              ) : (
                <div className={classes.svg}>
                  <FontAwesomeIcon icon={["fal", "building"]} fixedWidth />
                </div>
              )}
              <h3
                onClick={() => {
                  clearSearch();
                  setActiveAccount(account);
                }}
              >
                {account.name}
              </h3>
            </div>
          );
        });
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        {icon}
        <h2>{title}</h2>
        <div className={classes.grow} />
        {searching || (
          <Link to={`/editor/${account}|${team}|/new`}>New Tour</Link>
        )}
      </div>
      {children}
      <div className={classes.tours}>
        {searching
          ? getSearchTour()
          : loading
            ? getLoading()
            : sortedTours(tours).map(tour => <Tour key={tour.token} tour={tour} />)}
      </div>
    </div>
  );
};

export default Content;
